// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";


// Stateful components

export class MyGrades extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            results: null,
            program_tab_index: 0,
            active_rows: [],
            is_loading: true,
            mobile_tabs_active: false
        };

        // Binds
        this.setMyResults = this.setMyResults.bind(this);
        this.toggleMobileTabs = this.toggleMobileTabs.bind(this);
        this.resultsRowClicked = this.resultsRowClicked.bind(this);
        this.changeProgramTab = this.changeProgramTab.bind(this);
    }

    componentDidMount() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var successCallback = this_component.setMyResults;

        helpers.checkForGatekeeperData(successCallback, 'my_results', false);
    }

    setMyResults() {
        var this_component = this;
        var results_storage = squiz.fn.getStorage('getmyresults', 'session', 'json');

        if (results_storage && results_storage['data']) {
            this_component.setState({
                results: results_storage['data'],
                is_loading: false
            });
        } else {
            this_component.setState({
                is_loading: false
            });
        }
    }


    //
    // Events
    //

    toggleMobileTabs(e) {
        
        e.preventDefault();

        var this_component = this;
        var portal_context = this_component['context'];
        var viewport = portal_context['viewport'];

        if(viewport < 3) {
            var mobile_tabs_active = this_component['state']['mobile_tabs_active'];

            this_component.setState({
                'mobile_tabs_active': !mobile_tabs_active
            });
        }
    }

    resultsRowClicked(e) {
        
        e.preventDefault();

        var this_component = this;
        var clicked_index = e.currentTarget.getAttribute('data-index');
        var active_rows = [...this_component['state']['active_rows']];
        var index = active_rows.indexOf(clicked_index);

        if (index !== -1) {
            active_rows.splice(index, 1);
        } else {
            active_rows.push(clicked_index);
        }

        this_component.setState({
            active_rows: active_rows
        });
    }

    changeProgramTab(e) {

        e.preventDefault();

        var index = e.target.getAttribute('data-index');

        var this_component = this;
        this_component.toggleMobileTabs(e);

        this_component.setState({
            program_tab_index: Number(index)
        });
    }


    //
    // Functions
    //

    renderGrade(grade, grade_key, program_key) {
        var this_component = this;
       
        var item_state = '';
        var active_rows = this_component['state']['active_rows'];
        
        if (active_rows.indexOf(program_key + '-' + grade_key) !== -1) {
            item_state = " course-tile__assessment__item--open";
        }

        return (
            <>
                <div className={"course-tile__assessment__item course-tile__assessment__item--main"}>
                    
                    <div className="course-tile__assessment__item__col">
                        <div className="course-tile__assessment__item__title">
                            Class
                        </div>
                        <div className="course-tile__assessment__item__info">
                            {grade['subject']}
                        </div>
                    </div>
                    <div className="course-tile__assessment__item__col">
                        <div className="course-tile__assessment__item__title">
                            Units
                        </div>
                        <div className="course-tile__assessment__item__info"></div>
                    </div>
                    <div className="course-tile__assessment__item__col">
                        <div className="course-tile__assessment__item__title">
                            Official Grade
                        </div>
                        <div className="course-tile__assessment__item__info"></div>
                    </div>
                    <div className="course-tile__assessment__item__col">
                        <div className="course-tile__assessment__item__title">
                            Grade Points
                        </div>
                        <div className="course-tile__assessment__item__info"></div>
                    </div>
                </div>

                <div className={"course-tile__assessment__item" + item_state}>
                    
                    <button className="course-tile__assessment__item__toggler" data-index={program_key + '-' + grade_key} onClick={this_component.resultsRowClicked}>
                        {grade['subject']}
                    </button>
                    
                    <div className="course-tile__assessment__item__col">
                        <div className="course-tile__assessment__item__title">
                            Class
                        </div>
                        <div className="course-tile__assessment__item__info">
                            {grade['description']}
                        </div>
                    </div>
                    <div className="course-tile__assessment__item__col">
                        <div className="course-tile__assessment__item__title">
                            Units
                        </div>
                        <div className="course-tile__assessment__item__info">
                            {grade['unitsTaken']}
                        </div>
                    </div>
                    <div className="course-tile__assessment__item__col">
                        <div className="course-tile__assessment__item__title">
                            Official Grade
                        </div>
                        <div className="course-tile__assessment__item__info">
                            {grade['courseGradeOffered']}
                        </div>
                    </div>
                    <div className="course-tile__assessment__item__col">
                        <div className="course-tile__assessment__item__title">
                            Grade Points
                        </div>
                        <div className="course-tile__assessment__item__info">
                            {grade['gradePoints']}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    renderResultsTable(program, program_key) {
        var this_component = this;
        var grades = program['classGrades'];

        var academicStandingClasses = ['accad-stand'];
        var academicStandingString = "";

        if(program.academicStanding){  
            var academicStandingArr = program.academicStanding.split('-');
            if(academicStandingArr.length <= 1){
                academicStandingString = program.academicStanding;
            }else if(academicStandingArr.length === 2){
                academicStandingClasses.push(academicStandingArr[0].toLowerCase().trim().replace(' ','-'));
                academicStandingString = academicStandingArr[1].trim();
            }
        }
       // var academicStandingClassesString = academicStandingClasses.join

       //cumulativeGPA will be removed and replaced by programGPA this is a test to grab cumulative until program is available
       var displayGPA = "";
       if(program.programGPA){
            displayGPA = program.programGPA;
       }else{
        displayGPA = "C" + program.cumulativeGPA;
       }

      

        return (
            <>
                <div className="my-grades__table">
                    {grades.map(function(grade, grade_key) {
                        return (
                            <React.Fragment key={grade_key}>
                                {this_component.renderGrade(grade, grade_key, program_key)}
                            </React.Fragment>
                            
                        );
                    })}
                </div>
 
                <div className="my-grades__standing">
                    <ul className="my-grades__standing--details">
                        <li><strong>Term GPA:</strong> {program.currentGPA}</li>
                        <li><strong>Program GPA:</strong> {displayGPA}</li>
                        <li>
                            <strong>Academic Progress:</strong> 
                            <span className={academicStandingClasses.join(' ')}>
                                {academicStandingString}
                            </span>  
                            {this_component.renderAcademicLink(program)}                          
                        </li>
                    </ul>
                </div>
            </>
        );
    }
    renderAcademicLink(program){
        var academicStandingLink = "";
        if(program.academicStandingURL != null){
            academicStandingLink = program.academicStandingURL;
        }

        if(academicStandingLink == ''){
            return ;
        }else{
            return <a className="my-grades__link my-grades__link-academic" target="_blank"  href={academicStandingLink}>Learn More</a>
        }
    }

    //
    // Render
    //

    renderTabs(results) {
        var this_component = this;
        var portal_context = this_component['context'];

        var is_mobile = false;
        var viewport = portal_context['viewport'];
        if(viewport < 3) {
            is_mobile = true;
        }

        var program_index = this_component['state']['program_tab_index'];

        var mobile_tabs_active = this_component['state']['mobile_tabs_active'];
        var list_class = mobile_tabs_active ? ' page-tabs__list--open' : '';

        
        var no_of_tabs = results.length;
        
        var program_tabs = results.map(function(program, key) {
            
            var is_active = program_index === key ? true : false;
            var clickHandler = this_component.changeProgramTab;
            var tab_class = "page-tabs__item" + (is_active ? ' page-tabs__item--current' : '');
            
            if (is_mobile && is_active) {
                clickHandler = this_component.toggleMobileTabs;

                if (no_of_tabs !== 1) {
                    tab_class += ' page-tabs__item--toggle';
                }
            }
            var programLabel = "Error with Program API";
            if(program){
                programLabel = program.programDescription;
            }

            return (
                <li key={key} className={tab_class}>
                    <button data-index={key} onClick={clickHandler} className={"page-tabs__button"} >{programLabel}</button>
                </li>
            );
        });

        return (
            <div className="page-tabs__wrapper">
                <ul className={"page-tabs__list" + list_class}>
                    {program_tabs}
                </ul>
            </div>
        );
        
    }

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        var helpers = portal_context['helpers'];
        
        var is_loading = this_component['state']['is_loading'];
        var loading_image = configuration['images']['loader.gif']['url'];

        var is_mobile = false;
        var viewport = portal_context['viewport'];
        if(viewport < 3) {
            is_mobile = true;
        }

        var results = this_component['state']['results'];
        var program_index = this_component['state']['program_tab_index'];
        var program_tabs = null;
        var grade_tables = null;

        //if (results) {


        if(results === null || results.length === 1 && results[0] === null){
            return <div className="my-grades__wrapper"><p></p></div>
        }


        if (results !== null) {
            program_tabs = this_component.renderTabs(results);

            grade_tables = results.map(function(program, key) {
                return (
                    <div key={key} className={"my-grades__programs" + (program_index === key ? ' program--active' : '')}>
                        {this_component.renderResultsTable(program, key)}
                    </div>
                );
            });
        }


        var view_grades_url = helpers.getDynamicLinkUrlById('889831');
        var transcript_url = helpers.getDynamicLinkUrlById('889830');

        return (
            <div className="my-grades__wrapper">
               
                <a className="my-grades__link" href={view_grades_url}>View past grades</a>

                {!is_mobile && (
                    <a className="my-grades__link  my-grades__link--right" href={transcript_url}>View transcript</a>
                )}

                {is_loading ? (
                    <div className="loading__wrapper">
                        <img src={loading_image} alt="Loading..." />
                    </div>
                
                ) : (
                    <>
                        {results ? (
                            <div className="my-grades__content">
                                {program_tabs}
                                {grade_tables}
                            </div>
                            
                        ) : (
                            <p>Error loading your grades. Please try again later</p>
                        )}
                    
                    </>
                )}
                
            </div>

        );
    }

};

MyGrades.contextType = PortalContext;